import React from 'react';
import {
  Image,
  StyleProp,
  StyleSheet,
  TouchableOpacity,
  View,
  ViewStyle,
} from 'react-native';

import BadgeAppStore from 'web/assets/images/badge-apple-app-store.png';
import BadgePlayStore from 'web/assets/images/badge-google-play-store.png';

type Props = {
  style?: StyleProp<ViewStyle>;
  iosLink?: string;
  androidLink?: string;
};

const AppStoreBadgeLinks = (props: Props) => (
  <View style={[style.root, props.style]}>
    <TouchableOpacity
      accessibilityRole="link"
      href={props.iosLink || 'https://apps.apple.com/jp/app/paidy/id1220373112'}
      hrefAttrs={{
        target: '_blank',
      }}
    >
      <Image
        source={{ uri: BadgeAppStore }}
        style={[style.badge, style.badge1]}
      />
    </TouchableOpacity>
    <TouchableOpacity
      accessibilityRole="link"
      href={
        props.androidLink ||
        'https://play.google.com/store/apps/details?id=com.paidy.paidy&amp;hl=ja'
      }
      hrefAttrs={{
        target: '_blank',
      }}
    >
      <Image
        source={{ uri: BadgePlayStore }}
        style={[style.badge, style.badge2]}
      />
    </TouchableOpacity>
  </View>
);

const style = StyleSheet.create({
  root: {
    flexDirection: 'row',
  },
  badge: {
    width: 160,
    height: 47,
    resizeMode: 'contain',
  },
  badge1: {
    marginRight: 4,
  },
  badge2: {
    marginLeft: 4,
  },
});

export default AppStoreBadgeLinks;
